export const allInvestorCommunicationStatuses = ["Draft", "Preview", "Live"] as const;
export type InvestorCommunicationStatus = (typeof allInvestorCommunicationStatuses)[number];
